module.exports = __webpack_public_path__ + "media/images/pivot_265px-297b76163f7169a3f5d0900119996c960e6075c8b67e2241b87f5aee17720f85.jpg";